import { Project } from '~/types/project';

export default function targetITCPercent(project: Project) {
  const percentNumber = (project?.itcAdders ?? [])?.reduce(
    (acc: number, itcAdder: any) => {
      return acc + itcAdder.value;
    }, 30);

  return percentNumber + '%'; 
}